import request from '../../utils/request'

export default{
    namespaced: true,
    state:{
    charsets:[],//支持字符编码集
    },
    mutations:{
    //设置字符编码集
    setCharset(state,{data}){
        // console.log('res=====',res)
        state.charsets= data;
        }
    },
    actions:{
        //获取字符编码集
        async getCharset({commit, state}){
            const res = await request(
            {
                data:{
                    "header":{
                    'serviceCode': 'SYSTEM_SUPPORT_CHARSET',
                    "serviceName":"runtime_st"
                    },
                },
            }
            )
            let data = [];
            if(res.data.header.returnCode==='000000'){
                 data = res.data.body.data
            }
            commit('setCharset',{data})
              
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/modules/charset.js